<template>
    <div :class="{ 'custom-select': true, 'has-errors': errors.has( name ) }">

        <label v-if="labels[ name ]" :for="name"><slot>{{ labels[ name ] }}{{ ( rules[ name ] && rules[ name ].required ) ? '' : '' }}</slot></label>

        <select :id="name + '-select'" :name="name" v-model="value" v-validate="name ? rules[ name ] : null" @change="onChange" :tabindex="tabindex" :autocomplete="autocomplete">
            <option v-if="placeholder" value="" disabled selected>{{ placeholder }}</option>
            <template v-for="selectValue in selectValues">
                <option :value="selectValue" >{{ selectLabels ? selectLabels[ selectValue ] : selectValue }}</option>
            </template>
        </select>

        <!-- <span class="error">{{ errors.first( name ) }}</span> -->
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import { rules, labels } from '@/app/config';

    export default {
        inject: [ '$validator' ],

        model: {
            prop: 'selected',
            event: 'change'
        },

        props: {
            selected: {
                type: String,
                default: null
            },

            name: {
                type: String,
                default: 'select'
            },

            selectValues: {
                type: Array,
                default: () => [ 0, 1 ]
            },

            selectLabels: {
                type: Array,
                default: null
            },

            placeholder: {
                type: String,
                default: ''
            },

            tabindex: {
                type: String,
                default: ''
            },

            autocomplete: {
                type: String,
                default: ''
            }
        },

        data()
        {
            return {
                rules: rules,
                labels: labels,
                value: this.selected
            };
        },

        methods: {
            onChange( e )
            {
                this.$emit( 'change', e.target.value );
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/form-elements/CustomSelect.vue